/**
 * mailto: link for the booking page's "Contact Support" button.
 *
 * The address follows the same isTeamsEZ switch as the site header (HeaderNew.js), so TeamsEZ
 * directors don't email CampsEZ support. The body carries the booking reference and a link back to
 * the page, with a space above it for the director's question.
 */
export const getSupportEmail = isTeamsEZ => (isTeamsEZ ? 'support@teamsez.com' : 'support@campsez.com');

export const buildSupportMailto = ({ isTeamsEZ, bookingNumber, participantName, programName, programCode, bookingUrl }) => {
    const program = [programName, programCode ? `(${programCode})` : ''].filter(Boolean).join(' ');

    const subject = `Booking ${bookingNumber || ''}${programName ? ` - ${programName}` : ''}`;
    const body = [
        'Hi Support,',
        '',
        '[Please describe your question here]',
        '',
        '',
        '--',
        `Booking number: ${bookingNumber || 'N/A'}`,
        `Participant: ${participantName || 'N/A'}`,
        `Program: ${program || 'N/A'}`,
        `Booking link: ${bookingUrl}`,
    ].join('\n');

    return `mailto:${getSupportEmail(isTeamsEZ)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
